__turbopack_context__.v({
  "auth": "igdgSW_auth",
  "container": "igdgSW_container",
  "loading": "igdgSW_loading" + " " + "igdgSW_container",
  "shimmer": "igdgSW_shimmer",
  "text-bar-sweep": "igdgSW_text-bar-sweep",
});
